
import './styles/quasar.scss'
import lang from 'quasar/lang/pt-BR.js'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css'

import Notify from 'quasar/src/plugins/notify/Notify.js';import Loading from 'quasar/src/plugins/loading/Loading.js';import Dialog from 'quasar/src/plugins/dialog/Dialog.js';import Dark from 'quasar/src/plugins/dark/Dark.js';

// To be used on app.use(Quasar, { ... })
export default {
  config: {
    notify: {
      actions: [{ icon: 'close', color: 'white' }]
    }
  },
  plugins: {
    Notify,
    Loading,
    Dialog,
    Dark
  },
  lang: lang
}